//window.Popper = require('popper.js').default;
global.$ = global.jQuery = window.$ = window.jQuery = require('jquery');
require('slick-carousel');
require('../../../vendor/portfolio/gallery/src/resources/assets/js/lc_lightbox.js');
window.ShareAndSave = require('../../../vendor/portfolio/gallery/src/resources/assets/js/share.js');
//require('bootstrap');
//require('@popperjs/core');
require('./site');
require('./colorscheme');
require('./select');
require('./notify-dialog');
require('./share');

window.RobotChat = require('./robotchat.js');

import * as bootstrap from 'bootstrap'; // imports and auto-initializes properly
window.bootstrap = bootstrap; // expose API globally